import React from 'react';
import styles from './MailTo.module.css';

const MailTo = () => {
    return (
        <div className={styles.emailContainer}>
            <a 
                href="mailto:andi_frank19@hotmail.com"
                target="_blank"
                rel="noreferrer"
                className={styles.email}
            >
                andi_frank19@hotmail.com
            </a>
        </div>
    )
}

export default MailTo;